module.exports = __webpack_public_path__ + "static/media/17.cd97f008.jpg";